"use client";

import { loadStoryblokBridge } from "@storyblok/js";
import { Suspense, useEffect, useRef, useState } from "react";

import { StoryblokComponent } from "../StoryblokComponent";
import { useStoryblokContext } from "./StoryblokProvider";
import type { StoryblokStoryProps } from "./StoryblokStory";

export const ClientStoryblokStory = ({
  story,
  bridgeLess,
  ...rest
}: StoryblokStoryProps) => {
  const { onPublished } = useStoryblokContext();
  const [blokState, setBlokState] = useState(story.content);
  const hasRanRef = useRef(false);
  useEffect(() => {
    if (hasRanRef.current || bridgeLess) {
      return;
    }

    loadStoryblokBridge().then(() => {
      const { StoryblokBridge } = window;

      const storyblokInstance = new StoryblokBridge();

      storyblokInstance.on(["change", "published"], () => {
        onPublished?.();
      });

      storyblokInstance.on(["input"], (e) => {
        setBlokState(e?.story?.content);
      });

      hasRanRef.current = true;
    });
  }, [bridgeLess]);
  return (
    <Suspense>
      <StoryblokComponent {...rest} blok={blokState as any} preview />
    </Suspense>
  );
};
